import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import Masonry from "react-masonry-css";
import japan from "../../assets/places/japan/japan5.jpg";
import thailand from "../../assets/places/paris/thailand8.jpg";
import paris from "../../assets/places/paris/paris5.jpg";
import brazil1 from "../../assets/places/brazil/brazil.jpg";

const TravelSection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  const breakpointColumnsObj = {
    default: 2,
    700: 1,
  };

  const images = [
    { src: japan, alt: "Japan", country: "Japan" },
    { src: thailand, alt: "Thailand", country: "Thailand" },
    { src: brazil1, alt: "Brazil", country: "Christ the Redeemer" },
    { src: paris, alt: "Paris", country: "Eiffel Tower" },
  ];

  return (
    <div className="relative pt-8 dark:bg-black bg-white dark:text-white text-black bg-cover bg-center h-full">
      <div className="relative z-10 flex md:flex-row flex-col items-center justify-center gap-8 p-8">
        <div className="md:w-1/3 text-justify space-y-4" data-aos="fade-right">
          <div className="flex items-center space-x-2">
            {/* Use Playfair Display for headings */}
            <h2 className="text-4xl font-bold font-playfair">
              Travel made easy with TripDekhoo
            </h2>
          </div>
          {/* Use Open Sans for body text */}
          <p className="text-lg font-opensans">
            At Tripdekhoo, we believe that unforgettable travel experiences
            don’t have to come with a hefty price tag. Whether you’re looking
            for a quick weekend getaway or an extended vacation, we offer
            budget-friendly trip packages that let you explore more without
            breaking the bank.
          </p>
          <p className="text-lg font-opensans">
            Our team of experts carefully curates affordable travel packages,
            ensuring you get the most value for your money. From comfortable
            accommodations to hassle-free transportation and guided tours, we
            take care of the details so you can focus on the adventure ahead.
          </p>
          <div className="flex text-sm md:text-md flex-col md:flex-row pb-4 md:pb-0 md:space-x-4 space-y-4 md:space-y-0">
            <button
              onClick={() => navigate("/packages/Paris Anniversary Package")}
              className="w-full md:w-auto text-white bg-indigo-500 hover:bg-indigo-700 px-6 py-3 rounded-full font-bold transform transition-transform duration-300 hover:scale-105 shadow-lg text-center"
            >
              ANNIVERSARY PACKAGE
            </button>
            <button
              onClick={() => navigate("/packages/Maldives Honeymoon Package")}
              className="w-full md:w-auto text-white bg-indigo-500 hover:bg-indigo-700 px-6 py-3 rounded-full font-bold transform transition-transform duration-300 hover:scale-105 shadow-lg text-center"
            >
              HONEYMOON PACKAGE
            </button>
          </div>
        </div>
        <div className="md:w-1/2 pt-8">
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {images.map((image, index) => (
              <div key={index} className="relative overflow-hidden group">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-auto object-cover transition-transform duration-300 transform group-hover:scale-105"
                />
                <div className="absolute inset-0 top-0 right-0 bg-black flex items-center justify-center opacity-0 group-hover:opacity-50 transition-opacity duration-300">
                  <span className="text-stylish text-white text-xl font-playfair font-bold transform rotate-45 translate-x-6 -translate-y-6 transition-transform duration-300">
                    {image.country}
                  </span>
                </div>
              </div>
            ))}
          </Masonry>
        </div>
      </div>
    </div>
  );
};

export default TravelSection;
